(() => {
 document.querySelectorAll('.wb-specific-bar').forEach(bar => {
  if (bar.dataset.ready) return;
  bar.dataset.ready = 'true';
  const nav = bar.querySelector('nav'), button = bar.querySelector('button');
  const update = () => { button.hidden = nav.scrollWidth <= nav.clientWidth + 2; const end = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 3; button.setAttribute('aria-label',end ? 'First collections' : 'More collections'); button.querySelector('svg').style.transform = end ? 'rotate(180deg)' : ''; };
  button.addEventListener('click', () => { const end=nav.scrollLeft+nav.clientWidth>=nav.scrollWidth-3; nav.scrollTo({left:end?0:nav.scrollLeft+nav.clientWidth*.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); });
  nav.addEventListener('scroll',update,{passive:true}); new ResizeObserver(update).observe(nav); update();
 });
})();
